/**
 * Experiment to expose the new condensed version of the PDP to all clients: * https:www.notion.so/faire/Condensed-PDP-f0c8ba4088954f089dbd6d3034c4c8d0 * @deprecated Rolled back
 */
export const CONDENSED_PDP_XP_240409 = 'CONDENSED_PDP_XP_240409';
